<div class="app-body">
    <main class="main d-flex align-items-center">
        <div class="ap-login-languages"><app-languages></app-languages></div>
        <div class="container" (keyup.enter)="login(form.value)">
            <div class="row">
                <div class="col-md-8 offset-md-2 mx-auto">
                    <form [formGroup]="form">
                        <div class="card-group">
                            <div class="card p-4">
                                <div class="card-body">
                                    <div class="logo"></div>
                                    <div class="input-group mb-1" [ngClass]="{'has-danger': formHelper.hasErrorTooltip(form, username,'username')}" [tooltip]="'shell.username_min3' | transloco" triggers="" #username="bs-tooltip" placement="right">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="icon-user"></i></span>
                                        </div>
                                        <input type="text" class="form-control" formControlName="username" [ngClass]="{'form-control-danger':formHelper.hasError(form, 'username')}" [placeholder]="'shell.username' | transloco">
                                    </div>
                                    <div class="input-group mb-2" [ngClass]="{'has-danger':formHelper.hasErrorTooltip(form,password,'password')}" [tooltip]="'shell.password_min6' | transloco" triggers="" #password="bs-tooltip" placement="right">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text"><i class="icon-lock"></i></span>
                                        </div>
                                        <input type="password" class="form-control" formControlName="password" [ngClass]="{'form-control-danger':formHelper.hasError(form, 'password')}" [placeholder]="'route.password' | transloco">
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <button type="button" class="btn btn-primary btn-block" [disabled]="!form.valid" (click)="login(form.value)">{{ 'route.login' | transloco }}</button>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-12">
                                            {{ 'shell.reset_request_prefix' | transloco }}<a [routerLink]="['/reset-password']">{{ 'shell.here_link' | transloco }}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </main>
</div>
